import { Editor } from '@tiptap/core';

import { IconName } from 'components/elements/types';

import i18n from './i18n';

type HeadingOption = {
  name: string;
  icon: IconName;
  message: typeof i18n[keyof typeof i18n];
  isActive: (editor: Editor) => boolean;
  command: (editor: Editor) => void;
};

export const HEADING_OPTIONS: HeadingOption[] = [
  {
    name: 'paragraph',
    icon: 'TextT',
    message: i18n.headingNormal,
    isActive: (editor) => !editor.isActive('heading'),
    command: (editor) => editor.chain().focus().setParagraph().run(),
  },
  {
    name: 'h1',
    icon: 'TextHOne',
    message: i18n.headingH1,
    isActive: (editor) => editor.isActive('heading', { level: 1 }),
    command: (editor) =>
      editor.chain().focus().toggleHeading({ level: 1 }).run(),
  },
  {
    name: 'h2',
    icon: 'TextHTwo',
    message: i18n.headingH2,
    isActive: (editor) => editor.isActive('heading', { level: 2 }),
    command: (editor) =>
      editor.chain().focus().toggleHeading({ level: 2 }).run(),
  },
  {
    name: 'h3',
    icon: 'TextHThree',
    message: i18n.headingH3,
    isActive: (editor) => editor.isActive('heading', { level: 3 }),
    command: (editor) =>
      editor.chain().focus().toggleHeading({ level: 3 }).run(),
  },
];

export const activeHeadingOption = (editor: Editor): HeadingOption =>
  HEADING_OPTIONS.find((option) => option.isActive(editor)) ||
  HEADING_OPTIONS[0];
